/**
 * Analytics Portal V1 — Resource Analytics (Phase 15, plan §4.7 + §11 endpoint 8).
 * A pure renderer of `GET /api/analytics/resource` through the shared entity dashboard, plus the
 * Resource-only ratings section.
 */
import React from "react";
import { EntityDashboard } from "@/components/analytics/EntityDashboard";
import { RatingsSection } from "@/components/analytics/RatingsSection";
import { RESOURCE_GROUPS, RESOURCE_HEADLINE } from "@/components/analytics/resourceMetrics";
import { useAnalyticsPortal } from "./AnalyticsPortal";

export default function ResourcesTab() {
  const portal = useAnalyticsPortal();
  const payload = portal?.payload;

  return (
    <EntityDashboard
      portal={portal}
      testId="analytics-view-resources"
      scopeType="resource"
      headline={RESOURCE_HEADLINE}
      groups={RESOURCE_GROUPS}
      funnelTitle="Resource conversion funnel"
      noActivityBody="This resource's analytics will populate once eligible activity is collected."
      afterGroups={payload && (
        <RatingsSection ratings={payload.ratings}
                        rangeSuggestion={payload.range_suggestion}
                        onUseSupportedRange={portal.onUseSupportedRange} />
      )}
    />
  );
}
